const filterTypeEnum = Object.freeze({
  departureMonth: 'departureMonth',
  departureAirport: 'departureAirport',
  price: 'price',
  destination: 'destination',
});

export default filterTypeEnum;
